var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panel',{staticClass:"form-panel"},[_c('v-expansion-panel-header',[_vm._t("label",[_vm._v(_vm._s(_vm.label))])],2),_c('v-expansion-panel-content',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }